var _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M106.4,21.6C106.4,21.6,106.4,21.6,106.4,21.6C83-1.9,45-1.9,21.6,21.6C-1.9,45-1.9,83,21.6,106.4 C33.3,118.1,48.6,124,64,124c7.4,0,14.9-1.4,21.9-4.1c7.5-2.9,14.5-7.4,20.5-13.4c9.6-9.6,15.3-21.7,17-34.2 C125.9,54.3,120.3,35.4,106.4,21.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 36,
    fill: "#8ce5c3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#444b54",
    d: "M64,79c-0.8,0-1.6-0.3-2.1-0.9l-15-15c-1.2-1.2-1.2-3.1,0-4.2c1.2-1.2,3.1-1.2,4.2,0l12.7,12.7L91.7,39 c1.1-1.3,3-1.4,4.2-0.3c1.3,1.1,1.4,3,0.3,4.2l-30,35c-0.5,0.6-1.3,1-2.2,1C64.1,79,64,79,64,79z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#444b54",
    d: "M64,127C29.3,127,1,98.7,1,64S29.3,1,64,1s63,28.3,63,63S98.7,127,64,127z M64,7C32.6,7,7,32.6,7,64 s25.6,57,57,57s57-25.6,57-57S95.4,7,64,7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/done-icon.58ea6a51b81f41c55372ecbb4fa9e5a8.svg";
export { ForwardRef as ReactComponent };